module.exports = __webpack_public_path__ + "img/nav2.d2b9d9b8.png";